// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__iblgA","lowerCase":"styles_lowerCase__2B_Qz"};